/**
 * Case-insensitive check of the typed input against existing options' labels or
 * values (both the currently selected values and the available options).
 */
export const matchesExistingOption = (
  input: string,
  selectValue: readonly any[],
  selectOptions: readonly any[],
) => {
  const query = input.trim().toLowerCase()
  const matches = (o: any) =>
    String(o?.label ?? '').toLowerCase() === query ||
    String(o?.value ?? '').toLowerCase() === query
  return selectValue.some(matches) || selectOptions.some(matches)
}
